import React from 'react';
import {Route, Switch} from 'react-router-dom';
import MinhasContribuicao from './pages/Perfil';

import './assets/perfil.scss'
import AlterarDados from './pages/AlterarDados';

const PerfilPage: React.FC = () => {
    return (
        <>
            <Switch>
                <Route path="/perfil/inicio" exact={true} component={MinhasContribuicao}/>
                <Route path="/perfil/atualizar" exact={true} component={AlterarDados}/>
            </Switch>
        </>
    );
};
export default PerfilPage;
